import Swiper from 'swiper/dist/js/swiper';
import CardPopupTempl from './card-popup.pug';
import Form from '../../form/form';

export default {
  props: ['cardinfo', 'count', 'active'],
  template: CardPopupTempl(),
  delimiters: ['${', '}}'],
  components: {
    personalForm: Form(window.newCardForm),
  },
  data() {
    return {
      mainSlider: null,
      thumbSlider: null,
      thumb: null,
      main: null,
      options: null,
      activeTabs: null,
    };
  },
  mounted() {
    this.activeTabs = this.$el.querySelectorAll('.card-popup__tab--active');
    Array.from(this.activeTabs).forEach((tab) => {
      this.slidersInit(tab);
    });
  },
  methods: {
    slidersInit(tab) {
      const mainSlider = tab.querySelector('.card-popup__main-slider');
      const thumbSlider = tab.querySelector('.card-popup__thumb-slider');
      let sliderCounter = tab.querySelector('.sliderButtons__counter');

      this.thumb = new Swiper(thumbSlider, {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preloadImages: false,
        lazy: true,
        instance: null,
      });

      const thumbs = this.thumb;

      const options = {
        spaceBetween: 10,
        loop: true,
        preloadImages: false,
        nested: true,
        lazy: true,
        navigation: {
          nextEl: '.sliderButtons__btn--next',
          prevEl: '.sliderButtons__btn--prev',
        },
        thumbs: {
          swiper: this.thumb,
        },
        on: {
          init() {
            sliderCounter = this.el.querySelector('.sliderButtons__counter');
            if (sliderCounter) {
              sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
              sliderCounter.querySelector('[data-name=slidesLength]').textContent = this.slides.length - 2;
            }
            if (this.slides.length - 2 <= 1) {
              if (this.el.querySelector('.card-popup__slider-btns')) {
                this.el.querySelector('.card-popup__slider-btns').style.display = 'none';
              }
            }
            if (thumbs !== undefined) {
              const slides = [].slice.call(thumbs.slides);
              slides.forEach(tmp => tmp.classList.remove('card-popup__thumb-slide--active'));
              slides[this.realIndex].classList.add('card-popup__thumb-slide--active');
              thumbs.slideTo(this.realIndex);
            }
          },
          slideChange() {
            sliderCounter = this.el.querySelector('.sliderButtons__counter');
            if (sliderCounter) {
              sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
            }
            if (thumbs !== undefined) {
              const slides = [].slice.call(thumbs.slides);
              slides.forEach(tmp => tmp.classList.remove('card-popup__thumb-slide--active'));
              slides[this.realIndex].classList.add('card-popup__thumb-slide--active');
              thumbs.slideTo(this.realIndex);
              thumbs.activeIndex = this.realIndex;
              thumbs.clickedIndex = this.realIndex;
            }
          },
        },
      };

      if (mainSlider.querySelectorAll('.swiper-slide').length === 1) {
        options.loop = false;
      }

      this.main = new Swiper(mainSlider, options);
    },
    checkValue(e) {
      const galleryTabs = [].slice.call(this.$el.querySelectorAll('.card-popup__tab'));
      galleryTabs.forEach((elem) => {
        if (elem.dataset.name === e.target.value) {
          elem.classList.add('card-popup__tab--active');
          this.main.destroy();
          this.thumb.destroy();
          this.slidersInit(elem);
        } else {
          elem.classList.remove('card-popup__tab--active');
        }
      });
    },
    openFull() {
      let newArray = [];
      if (this.$el.querySelector('.card-popup__tab--active')) {
        newArray = this.cardinfo.btns.filter((elem => elem.id === this.$el.querySelector('.card-popup__tab--active').dataset.name));
      }
      this.$emit('fullscreen', {
        active: this.thumb.activeIndex,
        cards: newArray[0].slider,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./blocks/card/card-popup/card-popup.js